import ActionTypes from "../../../../constants/ActionTypes";
import ProductData from "../../../../entities/product/ProductData";
import {
  IProductState,
  IFetchProductAction,
  ISetProductAction,
  IEnrichProductAction,
  IGetProductDataAction,
  ISetProductDataAction,
  ISetProductCosmosInstallmentsAction,
  ISetProductContractObligationAction,
  ISetProductTariffAction,
  ISetProductColorAction,
  ISetProductInstallmentsOverBillPeriodAction,
  ISetProductCosmosModelAction,
  ISetPurchaseAction,
  ISetParticipation,
  ISetContractTypeAction,
  ISetProductPaymentTypeAction,
  IGetProductDataFromLocalStorageAction
} from "./types";

export function requestFetchProduct(params: object): IFetchProductAction {
  return {
    type: ActionTypes.PRODUCT.FETCH,
    params,
  };
}

export function setProductAction(product: object): ISetProductAction {
  return {
    type: ActionTypes.PRODUCT.SET,
    payload: product,
  };
}

export function enrichProductAction(product: IProductState): IEnrichProductAction {
  return {
    type: ActionTypes.PRODUCT.ENRICH,
    payload: { product }
  };
}

export function getProductDataFromLocalStorageAction(): IGetProductDataFromLocalStorageAction {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.GET_PRODUCT_DATA_FROM_LOCAL_STORAGE,
    payload: {}
  };
}

export function getProductDataAction(pageData: object, product: IProductState): IGetProductDataAction {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.GET_PRODUCT_DATA,
    payload: { pageData, product }
  };
}

export function setProductDataAction(productData: ProductData): ISetProductDataAction {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.SET_PRODUCT_DATA,
    payload: {
      tariff: productData.tariff,
      color: productData.color,
      cosmosInstallments: productData.cosmosInstallments,
      contract: productData.contract,
      participation: productData.participation,
      cosmosModel: productData.cosmosModel,
      paymentType: productData.paymentType,
      installments: productData.installments,
      purchase: productData.purchase,
      contractType: productData.contractType,
      type: productData.type,
      productId: productData.productId,
      isFilterEnable: productData.isFilterEnable,
    }
  };
}

export function setCosmosInstallmentsAction(cosmosInstallments: number): ISetProductCosmosInstallmentsAction {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.SET_COSMOS_INSTALLMENTS,
    payload: { cosmosInstallments }
  };
}

export function setContractAction(contract: number | string): ISetProductContractObligationAction {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.SET_CONTRACT_OBLIGATION,
    payload: { contract }
  };
}

export function setCosmosModelAction(cosmosModel: string): ISetProductCosmosModelAction {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.SET_COSMOS_MODEL,
    payload: { cosmosModel }
  };
}

export function setPaymentTypeAction(paymentType: string): ISetProductPaymentTypeAction {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.SET_PAYMENT_TYPE,
    payload: { paymentType }
  };
}

export function setInstallmentsOverBillPeriodAction(installmentsOverBillPeriod: boolean): ISetProductInstallmentsOverBillPeriodAction {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.SET_INSTALLMENTS_OVER_BILL_PERIOD,
    payload: { installmentsOverBillPeriod }
  };
}

export function setColorAction(color: number): ISetProductColorAction {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.SET_COLOR,
    payload: { color }
  };
}

export function setTariffAction(tariff: number): ISetProductTariffAction {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.SET_TP_ID,
    payload: { tariff }
  };
}

export function setParticipation(participation: number): ISetParticipation {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.SET_PARTICIPATION,
    payload: { participation }
  };
}

export function setPurchaseAction(purchase: string): ISetPurchaseAction {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.SET_PURCHASE,
    payload: { purchase }
  };
}


export function setContractTypeAction(contractType: string): ISetContractTypeAction {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_DATA.SET_CONTRACT_TYPE,
    payload: { contractType }
  };
}

export function productValidatorAction(product: IProductState) {
  return {
    type: ActionTypes.PRODUCT.PRODUCT_VALIDATOR,
    payload: {
      product,
    }
  };
}

